var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('h3', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_vm._v("\n    Compte rendu\n  ")]), _vm._v(" "), _c('add-button', {
    staticClass: "mx-5 md:mx-15 2xl:mx-20",
    attrs: {
      "libelle": "Ajouter un compte rendu"
    },
    on: {
      "add": _vm.addCR
    }
  }), _vm._v(" "), _vm.form.rendus.length > 0 ? _c('div', [_c('list-grid', {
    ref: "listCRs",
    attrs: {
      "list-items": _vm.form.rendus,
      "grid": "grid-cols-12",
      "is-accordion-items": true
    },
    on: {
      "displayNum": function (num) {
        _vm.crDisplayed = num;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-3 col-span-3 md:col-start-2 md:col-span-2"
        }, [_vm._v("\n          Date\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-7 md:col-span-5"
        }, [_vm._v("\n          Titre\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-3"
        }, [_vm._v("\n          Auteur\n        ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('icon', {
          staticClass: "text-pink-600 col-span-2 md:col-span-1 place-self-center transform transition-transform ease-in-out duration-300",
          class: {
            'rotate-90': _vm.crDisplayed == num
          },
          attrs: {
            "name": "chevron-right"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-3 md:col-span-2 text-base font-normal"
        }, [item.date_saisie ? _c('span', [_vm._v("\n            " + _vm._s(new Date(item.date_saisie).toLocaleDateString('fr')) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "col-span-7 md:col-span-5 text-base font-normal"
        }, [_vm._v("\n          " + _vm._s(item.titre) + "\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-3 text-base font-normal"
        }, [_vm._v("\n          " + _vm._s(item.auteur) + "\n        ")])];
      }
    }, {
      key: "accordionContent",
      fn: function (_ref2) {
        var item = _ref2.item,
          num = _ref2.num;
        return [_c('div', {
          staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('input-text', {
          staticClass: "md:col-span-4",
          attrs: {
            "name": "titre",
            "libelle": "Titre",
            "necessary": true,
            "value": item.titre
          },
          on: {
            "input": function (newValue) {
              item.titre = newValue;
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-4",
          attrs: {
            "name": "date_saisie",
            "necessary-date": true,
            "libelle": "Date",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.date_saisie
          },
          on: {
            "input": function (newValue) {
              item.date_saisie = newValue;
            }
          }
        }), _vm._v(" "), _c('tiptap', {
          attrs: {
            "name": "compte_rendu_tiptap",
            "necessary": true,
            "label": "Compte Rendu",
            "value": item.compte_rendu
          },
          on: {
            "update:value": function (newValue) {
              item.compte_rendu = newValue;
            }
          }
        }), _vm._v(" "), _c('delete-button', {
          staticClass: "w-max",
          attrs: {
            "libelle": "Supprimer ce compte rendu"
          },
          on: {
            "del": function ($event) {
              return _vm.deleteItem(_vm.form.rendus, num);
            }
          }
        })], 1)];
      }
    }], null, false, 138397621)
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }